import React, { Fragment, useEffect, useMemo } from 'react';
import {
    DefaultTableBodyRow,
    DefaultTableHead,
    Table,
    TableBody,
} from 'Common/components/table';
import PropTypes from 'prop-types';
import { useSortBy, useTable } from 'react-table';
import axios from 'axios';
import { useClickableTableRow } from 'Common/hooks/useClickableTableRow';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { useCustomCellStyles } from 'Common/hooks/useCustomCellStyles';
import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';

const StyledTableBodyRow = styled(DefaultTableBodyRow)`
    &:hover {
        background: ${colors.ALT_GRAY};
    }
`;

const StyledTableHead = styled(DefaultTableHead)`
    th {
        top: 81px;
    }
`;

const EmployeesTable = ({ employees }) => {
    const dispatch = useDispatch();

    const columns = useMemo(
        () => [
            {
                Header: 'Mitarbeiter',
                accessor: 'name',
                customCellStyles: {
                    minWidth: 220,
                    paddingTop: 20,
                    paddingBottom: 20,
                },
            },
        ],
        [],
    );

    const initialSortBy = useMemo(
        () => [
            {
                id: 'name',
                desc: false,
            },
        ],
        [],
    );

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    const data = useMemo(
        () =>
            employees.map(employee => ({
                name: `${employee.lastName}, ${employee.firstName}`,
                targetLink: `/archive/employee/${employee.id}`,
            })),
        [employees],
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            onRowClick: row => {
                dispatch(push(row.original.targetLink));
            },
            disableSortRemove: true,
            disableMultiSort: true,
            initialState: {
                sortBy: initialSortBy,
            },
        },
        useCustomCellStyles,
        useClickableTableRow,
        useSortBy,
    );

    return (
        <Table {...getTableProps()}>
            <StyledTableHead headerGroups={headerGroups} />
            <TableBody {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row);

                    return (
                        <Fragment key={`${row.getRowProps().key}_fragment`}>
                            <StyledTableBodyRow row={row} />
                        </Fragment>
                    );
                })}
            </TableBody>
        </Table>
    );
};

EmployeesTable.propTypes = {
    employees: PropTypes.array.isRequired,
};

export default EmployeesTable;
